<template>
  <div class="ordenes-subtrabajos-list" >
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :cliente="cliente"
          :articuloTipo="articuloTipo"
          :proveedor="proveedor"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Buscador de Ordenes a Proveedores">
          <b-table hover
              responsive="sm" 
              class="registro"
              :items="ordenesSubtrabajos"
              :fields="fields"
              :busy="tableBusy">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaOrden)="data">
              {{ data.item.fechaOrden | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
            <template v-slot:cell(detailShowing)="row">
              <b-btn class="detailShowing" 
                  size="sm" 
                  v-if="row.item.ordenTrabajoId != 0"
                  @click.stop="row.toggleDetails">
                {{ ( row.detailsShowing) ? '-' : '+' }}
              </b-btn>            
            </template>

            <template v-slot:cell(opciones)="data">
              <b-dropdown 
                  v-if="data.item.presupuestoInternoId != 0"
                  variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="consultarPresupuesto(data.item)">
                  <i class="fa fa-info"></i>Consultar Presupuesto</b-dropdown-item>
                <b-dropdown-item @click.stop="consultarPresupuestoProduccion(data.item)">
                  <i class="fa fa-info"></i>Consultar Información de Producción</b-dropdown-item>
                <b-dropdown-item 
                    v-if="opcionActualizarSubtrabajo"
                    @click.stop="moverSubtrabajo(data.item)">
                  <i class="fa fa-edit"></i>Mover Subtrabajo</b-dropdown-item>
              </b-dropdown>
            </template>

            <template v-slot:row-details="row">
              <b-row>
                <b-col cols="12">
                  <p>Información de la Orden de Trabajo:</p>
                </b-col>
              </b-row>
              <b-row v-if="row.item.ordenDescripcion != ''">
                <b-col cols="12">
                  <p class="descripcion">{{ row.item.ordenDescripcion }}</p>
                </b-col>
              </b-row>
              <b-row v-if="optionVerCotizacion">
                <b-col cols="12">
                  <p class="descripcion">Cotización: {{ row.item.ordenCotizacion | moneda }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <p class="descripcion">Costo Estimado: {{ row.item.ordenCostoEstimado | moneda }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <p class="descripcion">Costo Subtrabajos: {{ row.item.ordenCostoProveedor | moneda }}</p>
                </b-col>
              </b-row>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <b-modal ref="searchPresupuestoInternoModal" 
        title="Seleccionar Presupuesto Interno"
        header-bg-variant="light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-search-presupuesto
        :soloPresupuestosAbiertos="true"
        :seleccionarSubtrabajo="false"
        :opcionAgregarSubtrabajo="false"
        @presupuestoInternoSeleccionado="presupuestoInternoSeleccionado"
        @cancelaSeleccionPresupuestoInterno="cancelaSeleccionPresupuestoInterno">
      </app-search-presupuesto>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import SearchPresupuesto from '../presupuestosinternos/Search.vue';
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'ordenesSubtrabajos/getField',
  mutationType: 'ordenesSubtrabajos/updateField',
});

export default {
  name: 'OrdenesSubtrabajosList',
  components: {
    appSearchPresupuesto: SearchPresupuesto,
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  data: () => {
    return {
      fields: [
        {
            key: 'detailShowing',
            label: '',
            class: 'text-center'
        },
        // {
        //   key: 'presupuestoInternoId',
        //   label: 'Nro.PI',
        //   class: 'text-right'
        // },
        {
          key: 'presupuestoNumero',
          label: 'Nro.PI',
          class: 'text-right'
        },
        {
          key: 'cliente',
        },
        {
          key: 'accion',
        },
        {
          key: 'ordenTrabajoId',
          label: 'Nro.Orden',
          class: 'text-right'
        },
        {
          key: 'ordenRubro',
          label: 'Rubro Orden'
        },
        {
          key: 'articuloTipo',
          label: 'Tipo de Artículo'
        },
        // {
        //   key: 'rubroTrabajo',
        //   label: 'Rubro Artículo'
        // },
        {
          key: 'proveedor',
          label: 'Proveedor'
        },
        {
          key: 'fechaOrden',
          label: 'Orden'
        },
        {
          key: 'cantidad',
          class: 'text-right'
        },
        {
          key: 'importe',
          label: 'Costo Real Unit.',
          class: 'text-right'
        },
        // {
        //   key: 'costoTotal',
        //   label: 'Costo Total',
        //   class: 'text-right'
        // },
        // {
        //   key: 'diasProduccion',
        //   label: 'Dias Prod.',
        //   class: 'text-right' 
        // },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      ordenesTrabajosFields: [
        {
            key: 'descripcion',
        },
        {
            key: 'cotizacion',
        },
      ],

      tableBusy: false,

      optionVerCotizacion: false,
      opcionActualizarSubtrabajo: false,

      ordenSubtrabajoId: 0
    }
  },
  computed: {
    ...mapFields([
      'ordenesSubtrabajos',
      'fechaDesde',
      'fechaHasta',
      'cliente',
      'articuloTipo',
      'proveedor',
      'sortByDescending',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    }
  },
  created() {
    let userRolId = parseInt(this.$store.getters['user/rolId']);
    switch (userRolId) {
      case 4: /* Produccion */
      case 5: /* Diseño */
      case 10: /* Asistente de logistica */
      case 14: /* Asistente de produccion */
      case 24: /* Coordinador de Diseño */
        this.optionVerCotizacion = false;
        break;
      
      default:
        this.optionVerCotizacion = true;
        break;
    }

    switch (userRolId) {
      case 1:
      case 2: /* Direccion */
      case 8: /* Calidad */
      case 9: /* Director Ejecutivo */
        this.opcionActualizarSubtrabajo = true;
        break;
    }

    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.cliente = filtro.cliente;
      this.articuloTipo = filtro.articuloTipo;
      this.proveedor = filtro.proveedor;
      this.sortByDescending = filtro.sortByDescending;
      this.paginaActual = 1;

      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('ordenesSubtrabajos/getOrdenes')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    consultarPresupuesto(item) {
      this.$router.push({ name: 'PresupuestoInternoData', 
                          params: { id: item.presupuestoInternoId }});
    },
    consultarPresupuestoProduccion(item) {
      this.$router.push({ name: 'PresupuestoInternoProduccion', 
                          params: { id: item.presupuestoInternoId }});
    },
    moverSubtrabajo(item) {
      this.ordenSubtrabajoId = item.ordenSubtrabajoId;
      this.$refs.searchPresupuestoInternoModal;
      this.$refs.searchPresupuestoInternoModal.show()
    },
    presupuestoInternoSeleccionado(params) {
      this.$refs.searchPresupuestoInternoModal.hide();

      this.showModalConfirm('¿Desea mover el subtrabajo seleccionado?', 
            this.moverSubtrabajoSeleccionado.bind(this, params), 'Si', null, 'No')
    },
    cancelaSeleccionPresupuestoInterno() {
      this.$refs.searchPresupuestoInternoModal.hide()
    },
    moverSubtrabajoSeleccionado(params) {
      params.ordenSubtrabajoId = this.ordenSubtrabajoId;

      if (params.presupuestoInterno) {
        if (params.presupuestoInterno.id) {
          params.presupuestoInternoId = params.presupuestoInterno.id;
        }
      }

      if (params.ordenTrabajo) {
        if (params.ordenTrabajo.id) {
          params.ordenTrabajoId = params.ordenTrabajo.id;
        }
      }
      
      if (params.ordenSubtrabajo) {
        if (params.ordenSubtrabajo.id) {
          params.ordenSubtrabajoId = params.ordenSubtrabajo.id;
        }
      }

      this.showSpinner();
      this.$store.dispatch('ordenesSubtrabajos/moverSubtrabajo', params)
        .then(() => this.showModalMsj('El subtrabajo se actualizó con éxito.', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems() 
      }
    },    
  }    
}
</script>

<style>
.ordenes-subtrabajos-list .registro table td[aria-colindex="1"],
.ordenes-subtrabajos-list .registro table td[aria-colindex="12"] {
  width: 50px;
}
.ordenes-subtrabajos-list .registro table td[aria-colindex="2"] {
  width: 5%;
}
.ordenes-subtrabajos-list .registro table td[aria-colindex="3"] {
  /* width: calc(25% - 50px); */
  width: 15%;
}
.ordenes-subtrabajos-list .registro table td[aria-colindex="4"] {
  width: 15%;
}
.ordenes-subtrabajos-list .registro table td[aria-colindex="5"] {
  width: 5%;
}
.ordenes-subtrabajos-list .registro table td[aria-colindex="6"] {
  width: 15%;
}
.ordenes-subtrabajos-list .registro table td[aria-colindex="7"] {
  width: 15%;
}
.ordenes-subtrabajos-list .registro table td[aria-colindex="8"] {
  width: 15%;
}
.ordenes-subtrabajos-list .registro table td[aria-colindex="9"] {
  width: 5%;
}
.ordenes-subtrabajos-list .registro table td[aria-colindex="10"] {
  width: calc(5% - 50px);
}
.ordenes-subtrabajos-list .registro table td[aria-colindex="11"] {
  width: calc(5% - 50px);
}
</style>
